import React, { useEffect, useState } from 'react';
import TagManager from 'react-gtm-module';
import { Link } from 'react-router-dom';

import { btag, Bus, pushToDataLayer, SiteConfigManager, StorageManager } from '@atlas/core';
import { Cookies, Label } from '@atlas/ui';

import { isLocalEnv, LocalConfig } from 'common/utils/utils';
import { BASE_PATH, COOKIES_ACCEPTED_EVENT } from 'src/common/constants';
import { hasCustomGTM, initCustomGTM } from 'src/helpers/initCustomGTM';
import useHotjar from 'src/hooks/useHotjar';
import useMetaPixel from 'src/hooks/useMetaPixel';

const isOneButtonCookiesAllowedKey = 'isOneButtonCookiesAllowed';

export const OneButtonCookiesPopup = () => {
  const enableOneCookiesPopup = SiteConfigManager.getConfig(
    'config.config.general.enableCookiesPopup',
    true,
  );
  const cookiesType = SiteConfigManager.getConfig('config.config.general.cookiesType');
  const [isOneButtonCookiesAllowed, setIsOneButtonCookiesAllowed] = useState(
    StorageManager.getItem(isOneButtonCookiesAllowedKey),
  );
  const { initHotjar } = useHotjar();
  const projectId = LocalConfig.get('projectId');
  const { initMetaPixel } = useMetaPixel();

  useEffect(() => {
    if (!isLocalEnv && !hasCustomGTM(projectId)) {
      TagManager.initialize({
        gtmId: SiteConfigManager.getConfig('config.config.GTM'),
      });
    }

    initHotjar();

    if (String(projectId) === '296') {
      initMetaPixel(488782233535872);
    }

    if (hasCustomGTM(projectId) && !isLocalEnv) {
      initCustomGTM(projectId);
    }

    pushToDataLayer('homepage', btag);
  }, [initHotjar, projectId, initMetaPixel]);

  const onAllowOneButtonCookies = () => {
    StorageManager.setItem(isOneButtonCookiesAllowedKey, 'true');
    setIsOneButtonCookiesAllowed('true');
    Bus.emit(COOKIES_ACCEPTED_EVENT);
  };

  const logoPath = `${BASE_PATH}/static/assets/sprite/common/cookie.svg`;

  if (cookiesType && enableOneCookiesPopup && isOneButtonCookiesAllowed === null) {
    return (
      <Cookies
        className="one-button-cookies-popup"
        forbiddenText={<Label message="cookies_popup_forbidden_under_18" />}
        logo={logoPath}
        onClick={onAllowOneButtonCookies}
        textFirstPart={<Label message="cookies_we_use" />}
        textSecondPart={<Label message="cookies_in_order" />}
        title={<Label message="cookies" />}
      >
        <Link className="one-button-cookies-popup-link" to="/page/privacy-and-policy">
          cookies
        </Link>
      </Cookies>
    );
  }
  return null;
};
